module.exports = __webpack_public_path__ + "static/img/ixoye.292d8e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ixoye.png
// module id = ZVlC
// module chunks = 1